import { Reducer, useReducer } from "react";
import {
  ConfirmEvent,
  ConfirmEventContext,
  ConfirmState,
  ConfirmStateContext,
  defaultConfirmState,
} from "./ConfirmContext";
import { confirmReducer } from "./ConfirmReducer";

export type ConfirmReducer = Reducer<ConfirmState, ConfirmEvent>;

export function ConfirmContextProvider({ children }) {
  const [state, updateState] = useReducer(confirmReducer, defaultConfirmState);

  return (
    <ConfirmStateContext.Provider value={state}>
      <ConfirmEventContext.Provider value={updateState}>
        {children}
      </ConfirmEventContext.Provider>
    </ConfirmStateContext.Provider>
  );
}
